import { Component, OnInit } from '@angular/core';
import { CheckInType, OrderCheckInRequest } from '@app/core/redux/stores';
import { CheckInService } from '../../services/checkin.service';

@Component({
  selector: 'app-table-space-letter',
  templateUrl: './table-space-letter.component.html',
  styleUrls: ['./table-space-letter.component.less']
})
export class TableSpaceLetterComponent implements OnInit {
  public isTableSpaceSelected = false;
  selectedTableSpace = '';
  constructor(public checkIn: CheckInService) { }

  ngOnInit(): void {
    this.checkIn.loading = false;
  }
  setTableSpace() {
    this.isTableSpaceSelected  = true;
  }
  cancelCheckIn() {
    this.checkIn.hideModal();
  }
  checkInWithSpace(spaceNumber: string) {
    const orderCheckInRequest: OrderCheckInRequest = {
      checkInIndicator : spaceNumber, checkInType : CheckInType.Table};
    this.checkIn.checkIn(orderCheckInRequest);
  }
}
